export default defineComponent({
  props: {
    message: {
      type: String,
      required: true
    }
  }
});